import { render, staticRenderFns } from "./freeGoodsManage.vue?vue&type=template&id=2930ffca&scoped=true&"
import script from "./freeGoodsManage.vue?vue&type=script&lang=js&"
export * from "./freeGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./freeGoodsManage.vue?vue&type=style&index=0&id=2930ffca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2930ffca",
  null
  
)

export default component.exports